module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accept-terms",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-fw"
  }), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "startup terms"
    }
  }, [_vm._v("By using this application, you agree to the")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.tosLink,
      "target": "_blank"
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "startup"
    }
  }, [_vm._v("terms of use")])], 1), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "startup terms"
    }
  }, [_vm._v("and to the")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyLink,
      "target": "_blank"
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "startup terms"
    }
  }, [_vm._v("privacy policy")])], 1)], 1), _vm._v(" "), _c('p', [_c('strong', [_c('i', {
    staticClass: "fa fa-thumbs-up fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "startup terms"
    }
  }, [_vm._v("\n        Meteo-Parapente doesn't use tracking cookies\n      ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eb30ca1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accept-terms.vue
// module id = 328
// module chunks = 1